import raw from "./cipAiPlatformSysPrompt.md?raw";

/** Bedrock system prompt (built from capabilities head + ACTION/STRICT tail). */
export const SYS = raw;
